import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "parents-bind"
};
import IframeContainer from '@/components/IframeContainer/index.vue';
var url = 'https://report.zhixuehuijiao.cn/webroot/decision/view/duchamp?viewlet=parent_manage%252Fclass_parent_manage.fvs&ref_t=design';
export default {
  __name: 'ParentsBind',
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(IframeContainer, {
        src: url
      })]);
    };
  }
};